module.exports = {
      id: "webatvantage-usage",
      viewBox: "0 0 106 20",
      url: __webpack_public_path__ + "img/icons.bfe893b5.svg#webatvantage-usage",
      toString: function () {
        return this.url;
      }
    }